module.exports = __webpack_public_path__ + "static/media/solo_hymen4.883c6823.svg";